import { normalizeURL, withoutProtocol } from 'ufo';

export const companyFavicon = (website: string): string => {
    const value = withoutProtocol(website);

    return `https://favicon.twenty.com/${normalizeURL(value)}/192`;
};
